/**
 * Facility-scoped copay/co-insurance validation flag from Firestore healthcare_facility config.
 *
 * @module useValidateCopayCoinsuranceEnabled
 */
import { useSelector } from "react-redux";
import { isHealthFacilityFeatureEnabled } from "../data-model/healthFacility";
import { RootState } from "../redux/store/store";

/**
 * Returns whether copay and co-insurance are mandatory on EV coverage save/continue
 * for the logged-in user's healthcare facility (`validate_copay_coinsurance` in
 * `feature_config` / facility doc).
 *
 * @returns `true` when copay/co-insurance field validation is enabled for the facility.
 */
export const useValidateCopayCoinsuranceEnabled = (): boolean =>
  useSelector((state: RootState) =>
    isHealthFacilityFeatureEnabled(
      state.singleHealthFacilityDetails.data,
      "validate_copay_coinsurance",
    ),
  );
